import { history } from './HistoryService';

export const DEMO_USER_ID = "SQYsyi38XNYsGXdUsgZZ8X6R1cO2";

export function isDemo() {
  return history.location.pathname === '/demo'
}